<!-- <checkbox 
    *ngFor="let col of allColumns" 
    [single]="true"
    [inputId]="col.name"
    [ngModel]="isChecked(col)" 
    [inline]="true" 
    (onChange)="toggle(col)"
>
    {{ col.name }}
</checkbox> -->
<div class="mt-0">
  <div class="filterBox">
  <button class="btn btn-primary ml-2 mb-2" (click)="exportData()" >Export Data</button>
  <input type="text" placeholder="Filter By Date" [maxDate]="today" [(ngModel)]="daterang" name="daterang" (bsValueChange)="dateSelect($event)" class="form-control" bsDaterangepicker [bsConfig]="bsConfig">
  <button class="btn btn-primary ml-2 mb-2" (click)="reset()" >Reset Filter</button>  
  </div>
  <ngx-datatable
      #myTable
      class="material expandable"
      [rows]="rows"
      [columnMode]="ColumnMode.force"
      [headerHeight]="50"
      [footerHeight]="50"
      [rowHeight]="50"
      [scrollbarH]="false"
      [externalPaging]="true"
      [count]="page.totalElements"
      [offset]="page.pageNumber"
      [limit]="page.size"
      (page)="fetch($event.offset, false)">
    
        <!-- <ngx-datatable-column *ngFor="let col of columns" [name]="col.name" [prop]="col.prop" [width]="col.width?col.width:'150'"  [flexGrow]="(col.prop == '_id')?1:3" [cellTemplate]="col.prop === '_id' ? idTemplate : (col.prop === 'action' ? actTemplate : undefined)"></ngx-datatable-column> -->



        <!-- <ngx-datatable-row-detail [rowHeight]="100" #myDetailRow (toggle)="onDetailToggle($event)">
          <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
            <div class="row">
              <ng-container *ngFor="let item of selectedUser;">
                  <div class="col-lg-3" *ngIf="item.key != '_id' && item.key != 'followUp' && item.key != 'reminder'">
                      <h6>{{ item.key.replace('_',' ') | capitalize }}</h6>
                      <p>{{ item.value }}</p>
                  </div>
              </ng-container>
            </div>
          </ng-template>
        </ngx-datatable-row-detail> -->

        <!-- <ngx-datatable-column
          [width]="50"
          [resizeable]="false"
          [sortable]="false"
          [draggable]="false"
          [canAutoResize]="false"
        >
          <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
            <a
              href="javascript:void(0)"
              [class.datatable-icon-right]="!expanded"
              [class.datatable-icon-down]="expanded"
              title="Expand/Collapse Row"
              (click)="toggleExpandRow(row)"
            >
            </a>
          </ng-template>
        </ngx-datatable-column> -->
        <ngx-datatable-column name="Sr. No." [width]="80">
          <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <span class="showDetails" (click)="showMore(value,row)"><i class="feather icon-plus-circle"></i></span>
            <strong>{{row.inquiry_no?(row.inquiry_no):''}}</strong>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Action" [width]="90">
          <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
            <div class="btn-group" dropdown container="body">
                <button id="button-animated" dropdownToggle type="button" class="btn btn-primary dropdown-toggle" aria-controls="dropdown-container">
                    {{row.status}} <span class="caret"></span>
                </button>
                <ul id="dropdown-container" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-container">
                <li role="menuitem" *ngIf="row.status != 'In Touch'"><a class="dropdown-item" (click)="updateStatus(row._id, 'In Touch')">In Touch</a></li>
                <li role="menuitem" *ngIf="row.status != 'Dormant'"><a class="dropdown-item" (click)="updateStatus(row._id, 'Dormant')">Dormant</a></li>
                <li role="menuitem" *ngIf="row.status != 'Unread'"><a class="dropdown-item" (click)="updateStatus(row._id, 'Unread')">Unread</a></li>
                <li role="menuitem" *ngIf="row.status != 'Sucess'"><a class="dropdown-item" (click)="updateStatus(row._id, 'Success')">Success</a></li>
                <li role="menuitem" *ngIf="row.status != 'Disqualified'"><a class="dropdown-item" (click)="updateStatus(row._id, 'Disqualified')">Disqualified</a></li>
                </ul>
            </div>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Name" [width]="150">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <strong>{{row.name?row.name:(row.firstname?row.firstname:(row.first_name?row.first_name:(row.fname?row.fname:'-')))}}</strong>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Contact No" [width]="150">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <strong>{{row.contact_no?row.contact_no:(row.mobileno?row.mobileno:(row.contactNo?row.contactNo:(row.phone?row.phone:'-')))}}</strong>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Email" [width]="150">
          <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
            <strong>{{row.email?row.email:(row.emailAddress?row.emailAddress:(row.email_address?row.email_address:'-'))}}</strong>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Datetime" [width]="120">
          <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <strong *ngIf="row.datetime">{{row.datetime}}</strong>
            <strong *ngIf="!row.datetime">{{row.created_at |  date:'y-MM-dd H:mm:s'}}</strong>
          </ng-template>
        </ngx-datatable-column>
    </ngx-datatable>

</div>
<ng-template #idTemplate let-value="value" let-rowIndex="rowIndex" let-row="row">
    <span class="showDetails" (click)="showMore(value,row)"><i class="feather icon-plus-circle"></i></span>
    <strong>{{ getRowIndex(rowIndex) }} <br>{{row.inquiry_no?(row.inquiry_no):''}}</strong>
</ng-template>
<ng-template #actTemplate let-value="value" let-row="row">
    <div class="btn-group" dropdown container="body">
        <button id="button-animated" dropdownToggle type="button" class="btn btn-primary dropdown-toggle" aria-controls="dropdown-container">
            {{row.status}} <span class="caret"></span>
        </button>
        <ul id="dropdown-container" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-container">
        <li role="menuitem" *ngIf="row.status != 'In Touch'"><a class="dropdown-item" (click)="updateStatus(row._id, 'In Touch')">In Touch</a></li>
        <li role="menuitem" *ngIf="row.status != 'Dormant'"><a class="dropdown-item" (click)="updateStatus(row._id, 'Dormant')">Dormant</a></li>
        <li role="menuitem" *ngIf="row.status != 'Unread'"><a class="dropdown-item" (click)="updateStatus(row._id, 'Unread')">Unread</a></li>
        <li role="menuitem" *ngIf="row.status != 'Sucess'"><a class="dropdown-item" (click)="updateStatus(row._id, 'Success')">Success</a></li>
        <li role="menuitem" *ngIf="row.status != 'Disqualified'"><a class="dropdown-item" (click)="updateStatus(row._id, 'Disqualified')">Disqualified</a></li>
        </ul>
    </div>
</ng-template>
<ng-template #modelTemplate>
    <div class="modal-header">
      <h4 class="modal-title pull-left">Details</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <div class="userDetail">
            <h3>User Details</h3>
            <div class="row">
                <ng-container *ngFor="let item of selectedUser;">
                    <div class="col-lg-3" *ngIf="item.key != '_id' && item.key != 'followUp' && item.key != 'reminder'">
                        <h6>{{ item.key.replace('_',' ') | capitalize }}</h6>
                        <p *ngIf="item.key != 'created_at'">{{ item.value }}</p>
                        <p *ngIf="item.key == 'created_at'">{{ item.value | date:'y-MM-dd H:mm:s'}}</p>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="followUpBox">
            <h3>Follow Up Lead</h3>
            <div class="row">
                <div class="col-lg-5">
                    <label for="exampleFormControlTextarea1" class="form-label">followUp Note</label>
                    <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" [(ngModel)]="followupNote"></textarea>
                </div>
                <div class="col-lg-4">
                    <label class="form-label">Reminder Date</label>
                    <input type="text" placeholder="Datepicker" class="form-control" [(ngModel)]="remiderDate" bsDatepicker placement="top">
                </div>
                <div class="col-lg-3">
                    <label class="form-label">&nbsp;</label>
                    <button class="btn btn-primary ml-2" (click)="saveNote()">Add</button>
                </div>
            </div>
        </div>
        <div class="followUpList" *ngIf="followUpList.length>0">
            <h3>Follow Up List</h3>
            <table class="table">
                <thead>
                    <tr>
                        <th scope="row">Note</th>
                        <th scope="row">Reminder Date</th>
                        <th scope="row">Created Date</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of followUpList;">
                        <td>{{ item.note }}</td>
                        <td>{{ item.remider ? (item.remider  | date:'dd-MM-yyyy'):'-' }}</td>
                        <td>{{ item.date  | date:'dd-MM-yyyy' }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-template>